import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { getBusinessPartnerModel } from "../../BusinessPartner/Infrastructure/BusinessPartner.reducer";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import FormControl from "@mui/material/FormControl";
import { TextField } from "@mui/material";
import ButtonText from "../../DesignSystem/ButtonText";
import Divider from "@mui/material/Divider";
import MicNoneIcon from "@mui/icons-material/MicNone";
import BusinessCard from "../../DesignSystem/BusinessCard";
import HorizontalSelect from "../../DesignSystem/HorizontalSelect";
import CheckSelect from "../../DesignSystem/CheckSelect";
import {
  GetListCategories,
  GetBusinessList,
  GetBusinessListByCategory,
  GetBusinessListByName,
} from "../Infrastructure/Business.presenter";

const boxContainerStyles = {
  background: "white",
  width: { xs: "100%", sm: "100%", md: "90%" },
  height: "auto",
  maxWidth: "1110px",
  margin: { sm: "0px", md: "auto" },
  minHeight: "913px",
  padding: { xs: "60px 5px", sm: "40px 20px", md: "36px 40px 59px" },
};

const searchFormControl = {
  display: "flex",
  justifyContent: "center",
  gap: "10px",
  alignItems: { xs: "center", md: "baseline" },
  flexDirection: { xs: "column", md: "row" },
  width: { lg: "310px", md: "100%" },
};

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    flexWrap: "wrap",
    gap: 20,
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  title: {
    lineHeight: "58.09px",
    fontSize: "3rem",
    color: "#333333",
  },
  label: {
    fontWeight: 500,
    marginBottom: 9,
    textAlign: "left",
    fontSize: "1.125rem",
    lineHeight: "21.09px",
  },
  inputContainer: {
    width: 250,
    paddingBottom: 10,
    [theme.breakpoints.down("lg")]: {
      width: "100%",
      paddingBottom: "0px",
    },
  },
  selectStyles: {
    width: 206,
    height: 35,
    border: "none",
  },
  searchContainer: {
    padding: "10px 0px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
  },
  inputStyles: {
    border: "1px solid #E0E0E0",
    borderRadius: 5,
    width: 220,
    height: 35,
    paddingLeft: 10,
    fontWeight: 500,
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  businessContainer: {
    marginTop: 20,
    [theme.breakpoints.up("lg")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "20px 60px",
    },
  },
  businessType: {
    fontSize: "1.5rem",
    fontWeight: 500,
    textAlign: "left",
    marginTop: 40,
    [theme.breakpoints.down("md")]: {
      textAlign: "center",
    },
  },
  searchButton: {
    color: "white",
    border: "none",
    padding: 5,
    background: "#004890",
    width: 93,
    height: 35,
    borderRadius: 5,
    "&:hover": {
      cursor: "pointer",
      background: "#004890c7",
    },
  },
}));

export default function BusinessList() {
  const classes = useStyles();
  const businessPartner = useSelector(getBusinessPartnerModel);
  const [searchValue, setSearchValue] = useState("");
  const [searchCategoryValue, setSearchCategoryValue] = useState("");
  const [categories, setCategories] = useState([]);
  const [businessList, setBusinessList] = useState({});
  const [categoriesR, setCategoriesR] = useState(false);
  const [selectCategory, setSelectCategory] = useState(["Miscelánea"]);
  const [categoryTitle, setCategoryTitle] = useState("");
  const [businessR, setBusinessR] = useState(false);
  const [breakpoint, setBreakpoint] = useState(
    window.innerWidth <= 768 ? true : false
  );
  const [show, setShow] = useState(false);
  const elementRef = useRef();

  const getCategory = (value) => {
    setSelectCategory(value);
    handleBusinessCategory(value);
  };

  const getCategoryHorizontalArray = (value) => {
    setSelectCategory(value);
    handleBusinessCategory(value);
  };

  const handleBusinessCategory = async (searchCategory) => {
    const info = await GetBusinessListByCategory(
      businessPartner.zone,
      searchCategory
    );

    if (info === undefined || info === null || info.length === 0) {
      setCategoryTitle(searchCategory);
      setBusinessList(null);
    } else {
      setCategoryTitle(searchCategory);
      setBusinessList(info);
    }
  };

  const handleResizeTitle = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 768) {
      setBreakpoint(true);
    } else if (screenWidth >= 769) {
      setBreakpoint(false);
    }
  };

  useEffect(function () {
    const onChange = (entries, observer) => {
      const el = entries[0];
      if (el.isIntersecting) {
        setShow(true);
        observer.disconnect();
      }
    };
    const observer = new IntersectionObserver(onChange, {
      rootMargin: "100px",
    });
    observer.observe(elementRef.current);
    return () => observer.disconnect();
  });

  useEffect(() => {
    if (businessPartner) {
      fetchDataBusiness(businessPartner.zone);
      fetchCategories();
    }
    window.addEventListener("resize", handleResizeTitle);
    window.addEventListener("load", handleResizeTitle);
    return () => {
      window.removeEventListener("resize", handleResizeTitle);
      window.addEventListener("load", handleResizeTitle);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessPartner]);

  async function fetchDataBusiness(zone) {
    const info = await GetBusinessList(zone);
    setBusinessList(info);
    setBusinessR(true);
  }

  async function fetchCategories() {
    const info = await GetListCategories();
    const newCategories = [...categories];
    info.map((cat) => newCategories.push(cat.category_name));
    setCategories(newCategories);
    setCategoriesR(true);
  }

  const handleChangeInputSearch = (e) => {
    setSearchValue(e.target.value);
  };

  const getCategoryToInputSearch = (value) => {
    setSearchCategoryValue(value);
  };
  // Para buscar un negocio por nombre en la barra de búsqueda
  const handleBusinessNameSearch = async () => {
    try {
      const info = await GetBusinessListByName(
        businessPartner.zone,
        searchValue
      );
      setBusinessList(info);
      setSearchValue("");
      setCategoryTitle("");
    } catch (error) {
      console.log(error);
    }
  };
  // Para buscar por categoria en la barra de búsqueda del select de versión responsiva
  const handleBusinessCategorySearch = async () => {
    handleBusinessCategory(searchCategoryValue);
    setSearchCategoryValue("");
  };

  return (
    <Box sx={boxContainerStyles}>
      {breakpoint === false ? (
        <>
          <div className={classes.headerContainer}>
            <h3 className={classes.title}>NEGOCIOS</h3>
            <div className={classes.inputContainer}>
              {categoriesR ? (
                <>
                  <CheckSelect
                    options={categories}
                    defaultText={selectCategory}
                    handleValue={getCategory}
                  />
                </>
              ) : (
                <></>
              )}
            </div>
            <div className={classes.searchContainer}>
              <FormControl sx={searchFormControl}>
                <TextField
                  fullWidth
                  type="text"
                  variant="standard"
                  placeholder="Buscar negocios"
                  onChange={handleChangeInputSearch}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      handleBusinessNameSearch();
                    }
                  }}
                  id="busqueda"
                  value={searchValue}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: "#C4C4C4" }} />
                      </InputAdornment>
                    ),
                    disableUnderline: true,
                    classes: { root: classes.inputStyles },
                    sx: { fontSize: ".9rem" },
                  }}
                />
                <ButtonText
                  title="Buscar"
                  typeButton="button"
                  onClick={handleBusinessNameSearch}
                  widthBtn="100px"
                />
              </FormControl>
            </div>
          </div>
          <Divider sx={{ marginTop: "20px" }} />
        </>
      ) : (
        <div className={classes.headerContainer}>
          <div>
            <FormControl sx={searchFormControl}>
              <TextField
                fullWidth
                type="text"
                variant="standard"
                placeholder={"Buscar negocio"}
                onChange={handleChangeInputSearch}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleBusinessNameSearch();
                  }
                }}
                id="busqueda"
                value={searchValue}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#333333" }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <MicNoneIcon sx={{ color: "#004990" }} />
                    </InputAdornment>
                  ),
                  disableUnderline: true,
                  classes: { root: classes.inputStyles },
                  sx: { fontSize: ".9rem" },
                }}
              />
            </FormControl>
          </div>
          {categoriesR ? (
            <>
              <HorizontalSelect
                options={categories}
                selected={selectCategory}
                handleCategory={getCategoryHorizontalArray}
                searchValue={searchCategoryValue}
                handleInputSearch={getCategoryToInputSearch}
                handleFunction={handleBusinessCategorySearch}
              />
            </>
          ) : (
            <></>
          )}
        </div>
      )}

      <h3 className={classes.businessType}>{categoryTitle}</h3>
      <div ref={elementRef} id="cat" className={classes.businessContainer}>
        {show ? (
          businessList !== null && businessR ? (
            <>
              {businessList.map((shop) => (
                <BusinessCard
                  key={shop.id}
                  id={shop.id}
                  name={shop.shop_name}
                  image={shop.url_image}
                  schedule={shop.schedule}
                  description={shop.description}
                />
              ))}
            </>
          ) : (
            <p>Sin resultados</p>
          )
        ) : null}
      </div>
    </Box>
  );
}
